export default __webpack_public_path__ + "static/media/software-dev-kits.ce2bbfae.svg";